import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';

interface EmailToolTipProps {
}

interface EmailToolTipState {
    tooltipIsOpen: boolean;
}

export class EmailToolTipComponent extends React.Component<EmailToolTipProps, EmailToolTipState> {

    constructor(props: EmailToolTipProps) {
        super(props);
        this.state = {
            tooltipIsOpen: false,
        };
        this.showTooltip = this.showTooltip.bind(this);
        this.hideTooltip = this.hideTooltip.bind(this);
    }

    showTooltip() {
        this.setState({
            tooltipIsOpen: true,
        });
    }

    hideTooltip() {
        this.setState({
            tooltipIsOpen: false,
        });
    }

    public render() {

        const handleBlur = () => setTimeout(this.hideTooltip, 0);
        return (
            <div
                tabIndex={0}
                className="sid-why-email"
                aria-describedby="why-email"
                onMouseEnter={this.showTooltip}
                onMouseLeave={this.hideTooltip}
                onFocus={this.showTooltip}
                onBlur={handleBlur}
            >
                <span className="sid-link">
                    <FormattedHTMLMessage id="emailToolTip"
                        defaultMessage="Why?" />
                </span>
                {
                    this.state.tooltipIsOpen ?
                        <div className="sid-why-email__container">
                            <div className="sid-why-email__caret" />
                            <div className="sid-why-email__tooltip" role="tooltip" id="why-email">
                                <FormattedHTMLMessage
                                    id="step.personalInfo.whySchoolEmail"
                                    defaultMessage="Providing your school email address allows us to determine your eligibility for this exclusive teacher offer as quickly as possible."
                                />
                            </div>
                        </div>
                        :
                        null
                }
            </div>
        );
    }
}
